export default {
  newDesign: true,
  title: "Çocuklar için Matematik Dersleri | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQMRN2",
    segment: 12,
  },
  startPage: {
    title:
      "Çocuklar için Matematik Dersleri<br>Ücretsiz deneme dersine katılın",
    subtitle:
      "<img src=\"https://static.tildacdn.com/tild6337-3962-4830-b438-343836346435/Polygon_296_1.png\" style=\"width: 12px; height: 12px;\"> 5–11 yaş arası çocuklar için, uluslararası standartlara uygun ve oyun temelli eğitim modeli.<br><img src=\"https://static.tildacdn.com/tild3962-3433-4166-a136-313030396531/Group_1261156251.png\" style=\"width: 12px; height: 12px;\"> Uzman öğretmenlerimiz matematiği çocuklar için eğlenceli ve anlaşılır şekilde öğretir.",
    image: {
      url: "/welcome/tr_math_review_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/tr_math_review_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Ücretsiz deneme dersine katılın",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_math_review_skills.png",
      title: "Biz kimiz?",
      subtitle: "Kodland, 5–17 yaş arası çocuklara yönelik çevrimiçi bir eğitim platformudur. Öğrencilerimiz hayallerini gerçek projelere dönüştürerek dijital beceriler kazanır.",
      button: "Devam edelim",
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/tr_fwd_review_5.png",
      title: "Kodland ile daha hızlı öğrenin",
      subtitle: "Etkileşimli dersler ve bire bir mentor desteği sayesinde konuları daha hızlı anlar ve uzun süre aklınızda tutarsınız.",
      button: "Hemen başlayın",
    },
    3: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Burs değerlendirmesinde çocuğunuzun yaş grubu önemlidir. Lütfen yaşını seçin.",
      button: "İleri 🚀",
      tag: {
        text: "Program öğrencinin seviyesine göre uyarlanır",
        image: "/welcome/tc_offer_gift.png",
      },
    },
    4: {
      question: "Çocuğunuzun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
      subtitle: "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
      answers: [
        "🏫 Evet, okulda matematik eğitimi aldı",
        "👨‍👩‍👧 Evet, kendi başına ya da ailesiyle çalıştı",
        "📚 Evet, kurslarda veya özel derslerde eğitim aldı",
        "😊 Hayır, henüz deneyimi yok",
      ],
      tag: {
        text: "Öğretmenlerimiz titiz ve çok aşamalı bir seçim sürecinden geçer",
        image: "/welcome/tc_offer_gift.png",
      },
    },
    5: {
      question: "Çocuğunuzun ilgi alanları nelerdir?",
      answers: [
        "🎮 Oyun tasarımı",
        "💻 Kodlama",
        "✏️ Çizim ve animasyon",
        "🌐 Web tasarımı",
        "🧠 Mantık ve matematik",
        "🎯 Henüz emin değilim, birlikte keşfedelim"
      ],
      tag: {
        text: "Canlı ve etkileşimli çevrimiçi dersler",
        image: "/welcome/tc_offer_gift.png",
      },
    },
    6: {
      question: "Ücretsiz ilk dersten beklentiniz nedir?",
      answers: [
        "📊 Çocuğumun seviyesini öğrenmek",
        "🎯 Zorlandığı konuları görmek",
        "📈 Motivasyonunun artmasını sağlamak",
        "🎲 Matematiği oyunla öğrenmesini deneyimlemek"
      ],
      tag: {
        text: "Velilere düzenli ilerleme raporları gönderilir",
        image: "/welcome/tc_offer_gift.png",
      },
    },
    7: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    8: {
      title: "Son bir adım kaldı! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Çocuğunuzun matematikte özgüven kazanmasına ve analitik düşünmesini geliştirmesine birlikte destek olalım.",
      button: "Hadi başlayalım!",
    },
    9: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    12: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    13: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};